// extracted by mini-css-extract-plugin
export default {"container":"TableSkeleton_container__Istfd","header":"TableSkeleton_header__g8nxc"};